<script lang="ts">
	import Star from "@lucide/svelte/icons/star";
	import ShieldCheck from "@lucide/svelte/icons/shield-check";
	import Wallet from "@lucide/svelte/icons/wallet";
	import Section from "#lib/web-ui/primitives/section.svelte";
</script>

<Section class="bg-foreground/95">
	<div class="grid gap-8 md:grid-cols-3">
		<!-- Star Rating -->
		<div class="flex items-center gap-4">
			<div class="flex-shrink-0">
				<Star class="text-primary size-12" strokeWidth={1.5} />
			</div>
			<div>
				<h2 class="text-xl font-bold text-white">Sell Completely As-Is</h2>
				<p class="text-gray-300">No repairs, improvements needed</p>
			</div>
		</div>

		<!-- Years of Experience -->
		<div class="flex items-center gap-4">
			<div class="flex-shrink-0">
				<ShieldCheck class="text-primary size-12" strokeWidth={1.5} />
			</div>
			<div>
				<h3 class="text-xl font-bold text-white">20+ Years of Experience</h3>
				<p class="text-gray-300">We have helped 1,000s of home sellers</p>
			</div>
		</div>

		<!-- Cash Advance -->
		<div class="flex items-center gap-4">
			<div class="flex-shrink-0">
				<Wallet class="text-primary size-12" strokeWidth={1.5} />
			</div>
			<div>
				<h3 class="text-xl font-bold text-white">Keeps Your Money in Your Pocket</h3>
				<p class="text-gray-300">No upfront costs or out-of-pocket expenses</p>
			</div>
		</div>
	</div>
</Section>
